import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const POSTCODE_REGEXES: Record<string, RegExp> = {
  LV: /^[Ll][Vv][- ]{0,1}\d{4}$/, // Latvia
  PL: /^\d{2}-\d{3}$/, // Poland
  UA: /^\d{5}$/, // Ukraine
  AT: /^\d{4}$/, // Austria
  BE: /^\d{4}$/, // Belgium
  BG: /^\d{4}$/, // Bulgaria
  HR: /^\d{5}$/, // Croatia
  CY: /^\d{4}$/, // Cyprus
  CZ: /^\d{3}\s{0,1}\d{2}$/, // Czech Republic
  DK: /^\d{4}$/, // Denmark
  EE: /^\d{5}$/, // Estonia
  FI: /^\d{5}$/, // Finland
  FR: /.*/, // France
  DE: /^\d{5}$/, // Germany
  GR: /^\d{3}\s{0,1}\d{2}$/, // Greece
  HU: /^\d{4}$/, // Hungary
  IE: /.*/, // Ireland
  IT: /^\d{5}$/, // Italy
  LT: /^([Ll][Tt][- ]){0,1}\d{5}$/, // Lithuania
  LU: /^\d{4}$/, // Luxembourg
  MT: /^[A-Za-z]{3}\s{0,1}\d{4}$/, // Malta
  NL: /^\d{4}\s{0,1}[A-Za-z]{2}$/, // Netherlands
  PT: /^\d{4}[- ]{0,1}\d{3}$/, // Portugal
  RO: /^\d{6}$/, // Romania
  SK: /^\d{3}\s{0,1}\d{2}$/, // Slovakia
  SI: /^(SI-)?\d{4}$/, // Slovenia
  ES: /^\d{5}$/, // Spain
  SE: /^\d{3}\s{0,1}\d{2}$/, // Sweden
  GB: /^[A-Za-z]{1,2}\d([A-Za-z]|\d)?\s?\d[A-Za-z]{2}$/, // United Kingdom
  IL: /^\d{7}$/, // Israel
  RS: /^\d{5,6}$/, // Serbia
  AR: /^\d{4}$|^[A-Za-z]\d{4}[a-zA-Z]{3}$/, // Argentina
  AU: /^\d{4}$/, // Australia
  BR: /^\d{5}-\d{3}$/, // Brazil
  CL: /^\d{3}[-]{0,1}\d{4}$/, // Chile
  CO: /^\d{6}$/, // Colombia
  JP: /^\d{3}[-]{0,1}\d{4}$/, // Japan
  MY: /^\d{5}$/, // Malaysia
  MX: /^\d{5}$/, // Mexico
  PE: /^\d{5}$/, // Peru
  PH: /^\d{4}$/, // Philippines
  ZA: /^\d{4}$/, // South africa
  TH: /^\d{5}$/, // Thailand
  AE: /.*/, // UAE
  VN: /^\d{6}$/, // Vietnam
  NO: /^\d{4}$/, // Norway
  HK: /.*/, // Hong-Kong,
  CN: /^\d{6}$/, // China
  IN: /^\d{6}$/, // India
  AM: /^\d{4}$/, // Armenia
  CH: /^\d{4}$/, // Switzerland
};

export function postalCodeValidator(countryControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const postalCode = control.value;
    const postCodeRegexByCountry = POSTCODE_REGEXES[countryControl.value];

    if (!postalCode || !countryControl.value || !postCodeRegexByCountry) {
      return null;
    }

    const isValid = postCodeRegexByCountry.test(postalCode);

    return isValid ? null : { invalidCode: true };
  };
}
